import { render } from "./WordTest.vue?vue&type=template&id=59158023"
import script from "./WordTest.vue?vue&type=script&lang=js"
export * from "./WordTest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__